module.exports = __webpack_public_path__ + "static/media/filter-icon.5092675c.svg";